module.exports = __webpack_public_path__ + "img/kit.03822d8.gif";